/**
 * @generated SignedSource<<d08eb71795f6b1165a7d2aa6c61f073d>>
 * @relayHash cec1acb28f551cd4eca1808ab6700ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d1a68fa7599122acc2e993d24aa3207c388d0c0f4342238dd8fa5180543084aa

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d1a68fa7599122acc2e993d24aa3207c388d0c0f4342238dd8fa5180543084aa",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
